function isAxiomPersonalToken(token) {
    if (token.startsWith('xapt')) {
        return true;
    }
    return false;
}

export { isAxiomPersonalToken };
//# sourceMappingURL=token.js.map
